//frontend/src/components/ImageUploadDialog.js
import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ImageUploadDialog({ open, onClose, specialist, onUpload }) {
    const { t } = useTranslation();
    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    const handleUpload = async () => {
        if (selectedFile) {
            setLoading(true);
            try {
                await onUpload(specialist._id, selectedFile);
                setSelectedFile(null);
                setPreview(null);
                onClose();
            } catch (error) {
                console.error('Upload error:', error);
            }
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t('common.uploadSpecialistPhoto')}</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    {(preview || specialist?.image) && (
                        <Box sx={{ mb: 2 }}>
                            <img 
                                src={preview || specialist.image}
                                alt={specialist?.name}
                                style={{ 
                                    width: '200px', 
                                    height: '200px', 
                                    objectFit: 'cover',
                                    borderRadius: '4px'
                                }}
                            />
                        </Box>
                    )}
                    <Button variant="contained" component="label">
                        {t('common.selectimage')}
                        <input
                            hidden
                            accept="image/*"
                            type="file"
                            onChange={handleFileSelect}
                        />
                    </Button>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    {t('common.cancel')}
                </Button>
                <Button 
                    onClick={handleUpload}
                    disabled={!selectedFile || loading}
                    variant="contained"
                >
                    {loading ? <CircularProgress size={24} /> : t('common.upload')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}